import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ImportExcelState {
  importCode: string;
  file: File | null;
}

const initialState: ImportExcelState = {
  importCode: '',
  file: null,
};

const importExcelSlice = createSlice({
  name: 'importExcel',
  initialState,
  reducers: {
    setImportCode(state, action: PayloadAction<string>) {
      state.importCode = action.payload;
    },
    setImportFile(state, action: PayloadAction<File | null>) {
      state.file = action.payload;
    },
    resetImportExcelState(state) {
      state.importCode = '';
      state.file = null;
    },
  },
});

export const {
  setImportCode,
  setImportFile,
  resetImportExcelState,
} = importExcelSlice.actions;

export default importExcelSlice.reducer;
